module.exports = __webpack_public_path__ + "media/images/social/whatsapp-brands-70b225bc32cbd9b39689f647c0cc53ab.svg";